/* Every shop in the pickup drawer, not only the ones holding this suit.
   ------------------------------------------------------------------------
   Shopify lists a location against a variant only when that variant has an
   inventory record there, so a shop that has never stocked a particular suit
   disappears from the drawer entirely. A customer who lives by Wood Green is
   then told, in effect, that Wood Green does not exist — and the list looks
   different from product to product for no reason they can see.

   The shops themselves come from our own API, which reads them from Shopify
   once and caches them. Anything already in the drawer is left exactly as
   Shopify rendered it, stock and pickup times included; only the missing
   shops are appended, and plainly marked as not having it. */

(function () {
  'use strict';

  var CONFIG = document.querySelector('[data-tcfr-config]');
  var ENDPOINT = (function () {
    try {
      return CONFIG ? (JSON.parse(CONFIG.textContent) || {}).locationsEndpoint : null;
    } catch (e) {
      return null;
    }
  })();

  if (!ENDPOINT) return;

  function normalise(name) {
    return String(name || '').trim().toLowerCase();
  }

  function fill(drawer, locations) {
    var list = drawer.querySelector('ul');
    if (!list) return;

    var already = {};
    list.querySelectorAll('[role="heading"]').forEach(function (h) {
      already[normalise(h.textContent)] = true;
    });

    locations.forEach(function (loc) {
      if (already[normalise(loc.name)]) return;

      /* Built to match the markup Shopify rendered above it, so the appended
         shops are indistinguishable from the listed ones apart from what they
         say. Text nodes throughout — these are names and addresses. */
      var li = document.createElement('li');
      li.className = 'tc-store';

      var head = document.createElement('div');
      head.className = 'tc-store__head';
      var name = document.createElement('span');
      name.className = 'tc-store__name';
      name.setAttribute('role', 'heading');
      name.setAttribute('aria-level', '3');
      name.textContent = loc.name;
      head.appendChild(name);
      var tag = document.createElement('span');
      tag.className = 'tc-store__tag tc-store__tag--no';
      tag.textContent = 'Not here';
      head.appendChild(tag);
      li.appendChild(head);

      // One line, as in the rendered rows: street, town, postcode.
      var where = document.createElement('p');
      where.className = 'tc-store__where';
      where.textContent = (loc.address || []).slice(0, 2).join(', ');
      li.appendChild(where);

      if (loc.phone) {
        var tel = document.createElement('a');
        tel.className = 'tc-store__tel';
        tel.href = 'tel:' + String(loc.phone).replace(/\s+/g, '');
        tel.textContent = loc.phone;
        li.appendChild(tel);
      }

      list.appendChild(li);
      already[normalise(loc.name)] = true;
    });
  }

  var loaded = null;

  function run() {
    var drawer = document.querySelector('side-drawer[id^="pickup-availability"]');
    if (!drawer || drawer.__tcFilled) return;

    (loaded || (loaded = fetch(ENDPOINT, { credentials: 'omit' }).then(function (r) {
      return r.ok ? r.json() : { locations: [] };
    })))
      .then(function (data) {
        if (drawer.__tcFilled) return;
        drawer.__tcFilled = true;
        fill(drawer, (data && data.locations) || []);
      })
      .catch(function () {
        // The drawer still lists whatever Shopify knew about.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The drawer is re-rendered when the size changes, which drops the shops we
     appended — so the DOM is watched rather than filled once. */
  var observer = new MutationObserver(function () {
    var drawer = document.querySelector('side-drawer[id^="pickup-availability"]');
    if (drawer && !drawer.__tcFilled) run();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
